import { render } from "./Guilds.vue?vue&type=template&id=da395936&scoped=true"
import script from "./Guilds.vue?vue&type=script&lang=js"
export * from "./Guilds.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-da395936"

export default script